import React, { Component } from "react";
import { Link , withRouter } from "react-router-dom";
import "./index.css";
import CalendarPicker from "rc-calendar";
import axios from 'axios'
class View_type_24 extends Component {
	constructor(props) {
		super(props);

		var data = { list: [], ...props.data };
		this.state = {
			// counter:this.state.items_per_page ? this.state.items_per_page : null,
			data: data,
			width: 0,
			height: 0,
			isVisible:true,
			counter:data.items_per_page ? data.items_per_page : null,
			counterSecond:0,
		};
		//console.log("View_type_24: ", this.state);
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}
	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener("resize", this.updateWindowDimensions);
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateWindowDimensions);
	}
	updateWindowDimensions() {
		this.setState(() => {
			return {
				width: window.innerWidth,
				heigth: window.innerHeight
			};
		});
	}

updateHandler=()=>{
	this.updateNews();
}
updateNews = () => {
  axios
    .get(
      `https://api-muzeum.nifc.pl/index.php/middle_components_web/news/${
        this.state.counter
      }?lang=${this.state.data.button_lazy_load.lang}`
    )
    .then(res => {
      const data = res.data;
			if (res.data.list.length) {
				this.setState({
					data: {
						...this.state.data,
						list: this.state.data.list.concat(data.list)
					},
				 counter:this.state.counter *2,
				})
			}
    })
    .catch((error)=> {
			this.setState({
				isVisible:false
			})
    })
};


	render() {
		//console.log(this.props,'props');
		var object = this.state.data;
		// console.log("object2312323", object);
		/*
		check whether {object} is an array
		*/
		if (object.length) {
			// if (this.state.width>900) {
			return (
				<div className="vt24">
					<div className="vt24 row middle-scrollPoint">
						{object.map(function(object, i) {
							return (
								<div className="vt24 list-block">
									<div className="vt24 title">{object.header}</div>
									{object.list&& object.list.map(function(news, index) {
										index++;
										var category = news.category;
										var title = news.title;
										var description = news.description;
										var color = news.color;
										var image = news.image;
										var url = news.url;
										if (index !== 0 && index % 3 === 0) {
											return (
												<div key={index} className="small--inline">
													<div className="vt24 wrapped-item col-xs-12 col-sm-6 col-md-4 col-lg-4">
														<div className="vt24 middle-postblock"
															style={{cursor:'pointer'}}
															onClick={()=>window.location.href=`/${url}`}
															>
															<div className="vt24">
																<img className="vt24-img" src={image} alt="" />
																<div className="vt24 middlepost-thumbnail" />
																<div
																	className="vt24 load-element"
																	style={{ backgroundColor: color }}
																/>
															</div>
															<p
																className="vt24 middlepost-titldesc"
																dangerouslySetInnerHTML={{
																	__html: category.toUpperCase()
																}}
															/>
															<p
																className="vt24 middlepost-titleitem"
																dangerouslySetInnerHTML={{ __html: title }}
															/>
															<p
																className="vt24 middlepost-description"
																dangerouslySetInnerHTML={{
																	__html: description
																}}
															/>
															<div className="vt24 middle-addelem">
																<Link
																	className="vt24 more_button"
																	to={"/" + url}
																/>
															</div>
														</div>
													</div>
													<div className="clearfix" />
												</div>
											);
										}
										return (
											<div
												className="vt24 wrapped-item col-xs-6 col-sm-6 col-md-4 col-lg-4"
												key={index}
											>
												<div className="vt24 middle-postblock"
													style={{cursor:'pointer'}}
													onClick={()=>window.location.href=`/${url}`}>
													<div className="vt24">
														<img className="vt24-img" src={image} alt="" />
														<div className="vt24 middlepost-thumbnail" />
														<div
															className="vt24 load-element"
															style={{ backgroundColor: color }}
														/>
													</div>
													<p
														className="vt24 middlepost-titldesc"
														dangerouslySetInnerHTML={{
															__html: category.toUpperCase()
														}}
													/>
													<p
														className="vt24 middlepost-titleitem"
														dangerouslySetInnerHTML={{ __html: title }}
													/>
													<p
														className="vt24 middlepost-description"
														dangerouslySetInnerHTML={{ __html: description }}
													/>
													<div className="vt24 middle-addelem">
														<Link className="vt24 more_button" to={"/" + url} />
													</div>
												</div>
											</div>
										);
									})}
								</div>
							);
						})}
					</div>
				</div>
			);
			// }
		} else if (this.state.data.category == "compositions") {
			return (
				<div className="vt24 ">
					<div className="vt24 row middle-scrollPoint">
						<div className="vt24 list-block ">
							<div className="vt24 title">{object.header}</div>
							{object.list &&object.list.map(function(news, index) {
								index++;
								var category = news.category;
								var title = news.title;
								var description = news.description;
								var color = news.color;
								var image = news.image;
								var aptext = news.apla_text;
								var apbg = news.apla_background_color;
								var url = news.url;
								if (index !== 0 && index % 3 === 0) {
									return (
										<div key={index} className="small--inline">
											<div className="vt24 wrapped-item wrapped-item--compositions col-xs-12 col-sm-12 col-md-6 col-lg-6">
												<div className="vt24 middle-postblock"
													style={{cursor:'pointer'}}
													onClick={()=>window.location.href=`/${url}`}
													>
													<div className="vt24">
														<img className="vt24-img" src={image} alt="" />
														<div className="vt24 middlepost-thumbnail" />
														<div
															className="vt24 load-element"
															style={{ backgroundColor: color }}
														/>

													</div>
													<p
														className="vt24 middlepost-titldesc"
														dangerouslySetInnerHTML={{
															__html: category.toUpperCase()
														}}
													/>
													<p
														className="vt24 middlepost-titleitem"
														dangerouslySetInnerHTML={{ __html: title }}
													/>
													<p
														className="vt24 middlepost-description"
														dangerouslySetInnerHTML={{ __html: description }}
													/>
													<div className="vt24 middle-addelem">
														<Link className="vt24 more_button" to={"/" + url} />
													</div>
												</div>
											</div>
											{/* <div className="clearfix" /> */}
										</div>
									);
								}
								return (
									<div
										className="vt24 wrapped-item wrapped-item--compositions col-xs-6 col-sm-6 col-md-6 col-lg-6"
										key={index}
									>
										<div className="vt24 middle-postblock"
											style={{cursor:'pointer'}}
											onClick={()=>window.location.href=`/${url}`}
											>
											<div className="vt24">
												<img className="vt24-img" src={image} alt="" />
												<div className="vt24 middlepost-thumbnail" />
												<div
													className="vt24 load-element"
													style={{ backgroundColor: color }}
												/>
											</div>
											<p
												className="vt24 middlepost-titldesc"
												dangerouslySetInnerHTML={{
													__html: category.toUpperCase()
												}}
											/>
											<p
												className="vt24 middlepost-titleitem"
												dangerouslySetInnerHTML={{ __html: title }}
											/>
											<p
												className="vt24 middlepost-description"
												dangerouslySetInnerHTML={{ __html: description }}
											/>
											<div className="vt24 middle-addelem">
												<Link className="vt24 more_button" to={"/" + url} />
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div className="vt24 ">
					<div className="vt24 row middle-scrollPoint col-xs-12 col-sm-12 col-md-12 col-lg-12">
						<div className="vt24 list-block">
							<div className="vt24 title">{object.header}</div>
							{object.list&& object.list.map(function(news, index) {
								index++;
								var category = news.category;
								var title = news.title;
								var description = news.description;
								var color = news.color;
								var image = news.image;
								var aptext = news.apla_text;
								var apbg = news.apla_background_color;
								var url = news.url;
								if (index !== 0 && index % 3 === 0) {
									return (
										<div key={index} className="small--inline">
											<div className="vt24 wrapped-item col-xs-12 col-sm-12 col-md-4 col-lg-4">
												<div className="vt24 middle-postblock"
													style={{cursor:'pointer'}}
													onClick={()=>window.location.href=`/${url}`}
													>
													<div className="vt24 wrapper">
														<img className="vt24-img" src={image} alt="" />
														<div className="vt24 apla" style={{ backgroundColor: apbg }}

														/>
														<p className="vt24 apla apla-text"
																dangerouslySetInnerHTML={{ __html: aptext }}
														/>
														<div className="vt24 middlepost-thumbnail" />
														<div
															className="vt24 load-element"
															style={{ backgroundColor: color }}
														/>
													</div>
													<p
														className="vt24 middlepost-titldesc"
														dangerouslySetInnerHTML={{
															__html: category.toUpperCase()
														}}
													/>
													<p
														className="vt24 middlepost-titleitem"
														dangerouslySetInnerHTML={{ __html: title }}
													/>
													<p
														className="vt24 middlepost-description"
														dangerouslySetInnerHTML={{ __html: description }}
													/>
													<div className="vt24 middle-addelem">
														<Link className="vt24 more_button" to={"/" + url} />
													</div>
												</div>
											</div>
											<div className="clearfix" />
										</div>
									);
								}
								return (
									<div
										className="vt24 wrapped-item col-xs-6 col-sm-6 col-md-4 col-lg-4"
										key={index}
									>
										<div className="vt24 middle-postblock"
											style={{cursor:'pointer'}}
											onClick={()=>window.location.href=`/${url}`}
											>
											<div className="vt24 wrapper">
												<img className="vt24-img" src={image} alt="" />
												<div className="vt24 apla" style={{ backgroundColor: apbg }}

												/>
												<p className="vt24 apla apla-text"
														dangerouslySetInnerHTML={{ __html: aptext }}
												/>
												<div className="vt24 middlepost-thumbnail" />
												<div
													className="vt24 load-element"
													style={{ backgroundColor: color }}
												/>
											</div>
											<p
												className="vt24 middlepost-titldesc"
												dangerouslySetInnerHTML={{
													__html: category.toUpperCase()
												}}
											/>
											<p
												className="vt24 middlepost-titleitem"
												dangerouslySetInnerHTML={{ __html: title }}
											/>
											<p
												className="vt24 middlepost-description"
												dangerouslySetInnerHTML={{ __html: description }}
											/>
											<div className="vt24 middle-addelem">
												<Link className="vt24 more_button" to={"/" + url} />
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
					{this.state.data.items_per_page && this.state.isVisible &&
					<button style={{
						background:'#009CB2'
					}} className="button-load-news" onClick={this.updateHandler}>
						{this.state.data.button_lazy_load.text ?
						(this.state.data.button_lazy_load.text)
						:
						("Pokaż kolejne artykuły")}
					</button>
					}
				</div>
			);
		}
	}
}
export default withRouter (View_type_24)



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_24/index.js